export const ROW_LIMIT = 8;

export function rankRows(rows, segment, limit = ROW_LIMIT) {
  const gap = (row) => Math.max(segment.start - row.end, row.start - segment.end, 0);
  const ranked = rows
    .map((row, index) => ({ row, index, gap: gap(row) }))
    .sort((a, b) => a.gap - b.gap || a.row.start - b.row.start || a.row.name.localeCompare(b.row.name) || a.row.end - b.row.end || a.row.order - b.row.order);
  const more = ranked.slice(limit).reduce((sum, item) => sum + (item.row.count || 1), 0);
  return { order: ranked.map((item) => item.index), shown: Math.min(limit, ranked.length), more };
}

export function moreLabel(count) {
  if (count <= 0) return "";
  return `+${count} more ${count === 1 ? "schedule" : "schedules"} today`;
}

export function readRow(line) {
  return {
    start: Number(line.dataset.start),
    end: Number(line.dataset.end),
    name: line.dataset.name || "",
    count: Number(line.dataset.count) || 1,
    order: Number(line.dataset.order) || 0,
  };
}

export function arrangeCard(list, segment, limit = ROW_LIMIT) {
  const lines = Array.from(list.querySelectorAll(".tg-schedule-card-line"));
  const more = list.querySelector(".tg-schedule-card-more");
  const ranked = rankRows(lines.map(readRow), segment, limit);
  ranked.order.forEach((index, position) => {
    lines[index].hidden = position >= ranked.shown;
    list.insertBefore(lines[index], more);
  });
  more.textContent = moreLabel(ranked.more);
  more.hidden = ranked.more === 0;
  return ranked;
}
